import {useLayoutEffect, useRef, useState} from 'react';

import {COLLAPSED_HEIGHT} from '../constants';

export function useExpandableHourList(hoursCount: number) {
	const listRef = useRef<HTMLDivElement>(null);
	const [isExpanded, setIsExpanded] = useState(false);
	const [hasOverflow, setHasOverflow] = useState(false);

	useLayoutEffect(() => {
		const list = listRef.current;

		if (!list) return undefined;

		const measure = () => setHasOverflow(list.scrollHeight > COLLAPSED_HEIGHT);

		measure();

		if (typeof ResizeObserver === 'undefined') return undefined;

		const observer = new ResizeObserver(measure);
		observer.observe(list);

		return () => observer.disconnect();
	}, [hoursCount]);

	const handleToggleExpanded = () => {
		setIsExpanded(prev => !prev);
	};

	return {
		listRef,
		isExpanded,
		showToggle: hasOverflow,
		handleToggleExpanded,
	};
}
